<!-- login.component.html -->
<div class="row">
	<div class="column">
		<div class="row">
			<mat-grid-list cols="2" rowHeight="auto" gutterSize="16px">
			<mat-grid-tile> <mat-card> <mat-card-title>
			Authentification </mat-card-title> <mat-card-content>
			<form class="col s12 text-blue-grey text-darken-4"
				(ngSubmit)="onSubmit()">
				<div class="row">
					<div class="input-field col s6">
						<mat-form-field> <mat-label>Account</mat-label> <input
							type="text" id="selfsuperscription" name="selfsuperscription"
							[(ngModel)]="selfsuperscription" matInput> </mat-form-field>
					</div>
					<div class="input-field col s6">
						<mat-form-field> <mat-label>Password</mat-label>
						<input [(ngModel)]="password" id="password"
							[type]="hide() ? 'password' : 'text'"
							[ngModelOptions]="{standalone: true}" matInput>
						<button mat-icon-button matSuffix class="example-right-align"
							(click)="lookEvent($event)" [attr.aria-label]="'Hide password'"
							[attr.aria-pressed]="hide()">
							<mat-icon>{{hide() ? 'visibility_off' : 'visibility'}}</mat-icon>
						</button>
						</mat-form-field>
					</div>

				<button class="btn waves-effect waves-light indigo lighten-2"
					type="submit" name="action" mat-raised-button>.`-</button>
					
				</div>
			</form>
			<button class="btn waves-effect waves-light indigo lighten-2
"
				type="button" name="action" (click)="google()" mat-raised-button>G</button>
			<button class="btn waves-effect waves-light  indigo lighten-2
"
				type="button" name="action" (click)="vk()" mat-raised-button>V</button>
			<button class="btn waves-effect waves-light indigo lighten-2
"
				type="button" name="action" (click)="x()" mat-raised-button>X</button>
			<button class="btn waves-effect waves-light indigo lighten-2
"
				type="button" name="action" (click)="facebook()" mat-raised-button>F</button>
			</mat-card-content></mat-card></mat-grid-tile></mat-grid-list>
		</div>
	</div>
</div>